<template>
  <div class="card">
    <div class="card-header text-center py-2">Categorias</div>
    <div class="card-body">
      <div class="row">
        <div class="col-sm-6">
          <div class="list-group">
            <div class="list-group-item bg-light">
              Lista de categorias
              <div class="float-right">
                <button
                  v-if="listaCategoria && listaCategoria.length > 0"
                  class="btn btn-sm btn-secondary mr-1"
                  title="Ver lista Principal de categorias"
                  @click="listaPrincipal">
                  Categorias
                </button>
                <button
                  class="btn btn-sm btn-info"
                  @click="nuevaCategoria">
                  Nueva
                </button>
              </div>
            </div>
            <div class="list-group-item">
              <ul v-if="listaCategoria">
                <ManteCartaCategoriaArbol
                  class="item"
                  v-for="(items, index) in listaCategoria"
                  :key="index"
                  :item="items"
                  @ver-detalle="setDetalle"
                  @set-activo="activarItem">
                </ManteCartaCategoriaArbol>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-sm-6" v-if="verForm">
          <div class="list-group m-0">
            <div class="list-group-item">
              <nav>
                <div class="nav nav-tabs" id="nav-opciones" role="tablist">
                  <a class="nav-link active" id="nav-categorias-tab" data-toggle="tab" href="#nav-categorias" role="tab" aria-controls="nav-categorias" aria-selected="true">Categorias</a>
                  <a class="nav-link" id="nav-redes-tab" data-toggle="tab" href="#nav-redes" role="tab" aria-controls="nav-redes" aria-selected="false" v-if="reg != '' && form.bazar==1">Redes sociales</a>
                </div>
              </nav>
              <div class="tab-content" id="nav-contenidos">
                <div class="tab-pane fade show active" id="nav-categorias" role="tabpanel" aria-labelledby="nav-categorias-tab">
                  <p class="text-info" v-if="detalle">Todos los registros serán agregados a:</p>
                  <p class="text-info" v-else>Está creando una nueva categoria</p>
                  <h5 class="text-center" v-if="detalle">{{ detalle.padre.descripcion }}</h5>

                  <form autocomplete="off" @submit.prevent="guardar">
                    <div class="form-group row mb-2">
                      <div class="col-sm-12">
                        <label for="inputNombre">Nombre:</label>
                        <input type="text" id="inputNombre" class="form-control form-control-sm" v-model="form.descripcion">
                      </div>
                    </div>
                    <div class="form-group row mb-2" v-if="!form.carta_categoria_id">
                      <div class="col-sm-12">
                        <label for="inputLogo">Logo:</label>
                        <input type="file" id="inputLogo" @change="inputLogo" class="form-control-file form-control-file-sm" accept="image/*">
                      </div>
                    </div>
                    <div class="form-group row mb-2" v-if="!form.carta_categoria_id">
                      <div class="col-sm-12">
                        <label for="texto">Texto:</label>
                        <textarea class="form-control" id="texto" cols="30" rows="3" maxlength="250" v-model="form.texto"></textarea>
                      </div>
                    </div>
                    <div class="form-group row mb-2" v-if="!form.carta_categoria_id">
                      <div class="col-sm-6">
                        <div class="custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input" v-model="form.bazar" id="bazar" :true-value="1" :false-value="0">
                          <label class="custom-control-label" for="bazar">Bazar</label>
                        </div>
                      </div>
                      <div class="col-sm-6" v-if="form.bazar">
                        <div class="custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input" v-model="form.externo" id="externo" :true-value="1" :false-value="0">
                          <label class="custom-control-label" for="externo">Externo</label>
                        </div>
                      </div>
                    </div>
                    <div class="form-group row mb-2" v-if="!form.carta_categoria_id && form.externo == 1 && form.bazar == 1">
                      <div class="col-sm-12">
                        <label for="inputEnlace">Enlace:</label>
                        <input type="url" id="inputEnlace" class="form-control form-control-sm" v-model="form.enlace" required>
                      </div>
                    </div>
                    <div class="form-group row mb-2" v-if="form.bazar == 1">
                      <div class="col-sm-12">
                        <label for="inputCorreo">Correo:</label>
                        <input type="email" id="inputCorreo" class="form-control form-control-sm" v-model="form.correo" :required="true">
                      </div>
                    </div>

                    <div class="form-group row mb-3">
                      <div class="col-sm-12 text-right">
                        <button
                          type="button"
                          class="btn btn-sm btn-secondary mr-1"
                          v-if="reg !== ''"
                          @click.prevent="limpiar"
                        >
                          Nuevo
                        </button>
                        <button type="submit" class="btn btn-sm btn-primary" :disabled="btnGuardar">
                          <span
                            class="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                            v-if="btnGuardar"
                          ></span>
                          <span class="sr-only" v-if="btnGuardar">
                            {{ reg === '' ? 'Guardando...':'Actualizando...' }}
                          </span>
                          <span v-if="!btnGuardar">
                            {{ reg === '' ? 'Guardar':'Actualizar' }}
                          </span>
                        </button>
                      </div>
                    </div>
                  </form>
                  <div class="table-responsive">
                    <table class="table table-sm table-condensed table-bordered">
                      <thead>
                        <tr>
                          <th colspan="3"></th>
                        </tr>
                        <tr>
                          <th>#</th>
                          <th>Descripción</th>
                          <th width="50px"></th>
                        </tr>
                      </thead>
                      <tbody v-if="detalle">
                        <tr v-for="(i,indexh) in detalle.hijos" :key="indexh">
                          <td>{{ indexh+1 }}</td>
                          <td>
                            <a href="#" @click="editar(indexh)">
                              {{ i.padre.descripcion }} 
                              <div  v-if="i.padre.carta_categoria_id === null">
                                <span class="badge badge-secondary">Principal</span> 
                                <span 
                                  v-if="i.hijos" 
                                  class="badge badge-primary ml-2"
                                >{{ i.hijos.length }} subcategorías</span>
                              </div>
                            </a>
                          </td>
                          <td class="text-center">
                            <input type="checkbox" v-model="anular" :value="i.padre.id">
                          </td>
                        </tr>
                      </tbody>
                      <tfoot v-if="anular.length > 0">
                        <tr>
                          <td colspan="100%" class="text-right">
                            <button class="btn btn-sm btn-danger"
                              title="Anular productos"
                              v-if="anular.length > 0"
                              :disabled="btnAnular"
                              @click="anularCategoria">
                              <span
                                class="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                                v-if="btnAnular"
                              ></span>
                              <font-awesome-icon v-else icon="times" />
                            </button>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                <div class="tab-pane fade" id="nav-redes" role="tabpanel" aria-labelledby="nav-redes-tab" v-if="reg != '' && form.bazar==1 ">
                  <ManteBazarRedes :tipo="2" :categoria="form"></ManteBazarRedes>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  import ManteCartaCategoriaArbol from './ManteCartaCategoriaArbol.vue';
  import ManteAccion from '../mixins/ManteAccion.js';
  import ManteBazarRedes from './ManteBazarRedes.vue';
  import $ from 'jquery'

  export default {
    name: 'ManteCartaCategoria',
    mixins: [ManteAccion],
    data: () => ({
      listaCategoria: null,
      btnAnular: false,
      anular: [],
      detalle: null,
      verForm: false,
      form: {}
    }),
    methods: {
      buscar () {
        axios
        .get(this.UrlBase+'/catalogo/get_categoria')
        .then(res => {
          this.listaCategoria = res.data.lista;
        }).catch(e => {
          alert("Cat "+e);
        });
      },
      setDetalle (cat) {
        this.verForm = true;
        this.detalle = cat;
  
        if (cat) {
          this.form.carta_categoria_id = cat.padre.id;
        } else {
          this.form.carta_categoria_id = null;
        }
        $("#nav-categorias-tab").click()
      },
      nuevaCategoria () {
        this.verForm = true;
        this.detalle = null;
        this.form = {};
        this.limpiarActivo();
        $("#nav-categorias-tab").click()
      },
      guardar () {
        this.btnGuardar = true;
        let datos = new FormData();

        for (const key in this.form) {
          if (this.form[key] !== null) {
            datos.append(key, this.form[key]);
          }
        }
        
        axios
        .post(this.UrlBase+'/mante/set_categoria/'+this.reg, datos)
        .then(res => {
          if (res.data.exito) {
            this.showSuccessMsg({message: res.data.mensaje});

            if (!this.reg) {
              if (this.detalle) {
                if (this.detalle.hijos) {
                  this.detalle.hijos.push({'padre':res.data.linea});
                } else {
                  this.detalle.hijos = [{'padre':res.data.linea}];
                }
              } else {
                this.listaCategoria.push({'padre':res.data.linea});
                this.setDetalle({'padre':res.data.linea});
              }
              this.form.descripcion = null;
            }
            this.buscar();
          } else {
            this.showWarnMsg({message: res.data.mensaje});
          }

          this.btnGuardar = false;
        }).catch(e => {
          this.btnGuardar = false;
          this.showErrorMsg({message: 'Categoria '+e});
        });
      },
      editar (idx) {
        let tmp = this.detalle.hijos[idx].padre;
        this.reg = tmp.id;
        this.form = tmp;
        this.verForm = true;
      },
      listaPrincipal() {
        this.limpiarActivo();
        this.verForm = true;
        this.form = {};
        
        this.detalle = {
          padre: {descripcion: 'Lista Principal'},
          hijos: this.listaCategoria
        }
      },
      anularCategoria () {
        if (confirm('¿Está seguro?')) {
          this.btnAnular = true;

          axios
          .post(this.UrlBase+'/anular/categoria', {categorias: this.anular})
          .then(res => {
            if (res.data.exito) {
              this.anular = [];
              this.nuevaCategoria();
              this.buscar();
            } else {
              this.showErrorMsg({message: res.data.mensaje});
            }
            this.btnAnular = false;
          }).catch(e => {
            this.btnAnular = false;
            alert("Anular "+e);
          })
        }

      },
      limpiarActivo () {
        let items = document.getElementsByClassName('xitem');
        for (var i = items.length - 1; i >= 0; i--) {
          items[i].classList.remove('bg-primary');
          items[i].classList.remove('text-white');
        }
      },
      activarItem (e) {
        this.limpiarActivo();
        e.target.classList.add('bg-primary');
        e.target.classList.add('text-white')
      },
      inputLogo(e) {
        let files = e.target.files || e.dataTransfer.files;
        if (!files.length)
        return;
        this.form.logo = files[0];
      },
    },
    components: {
      ManteCartaCategoriaArbol,
      ManteBazarRedes
    }
  }
</script>